import { FC, useMemo } from 'react'
import { AssetOption } from 'components/features/future/types'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import styles from 'components/features/future/AssetsList/AssetsList.styl'
import { RadioButton } from 'components/atoms/inputs/RadioButton/RadioButton'
import { formatUSCurrency } from 'helpers/formatHelpers'
import moment from 'moment'

type AssetsListProps = {
  type: 'car' | 'home'
  assets: AssetOption[] | null
  name: string
  date: string
}
export const AssetsList: FC<AssetsListProps> = (props) => {
  const { assets, name, date, type } = props

  const childrenChild = useMemo(() => {
    if (assets === null) {
      return (
        <LoadingOverlay />
      )
    }

    if (assets.length === 0) {
      return (
        <>
          No options available
        </>
      )
    }

    return assets.map(({ name: optionName, uid, source, value }) => (
      <div key={ uid } className={ styles.option }>
        <div className={ styles.source }>
          { source === 'assumptions' && (
            <>From Forecast Assumptions</>
          )}
          { source === 'layer' && (
            <>From Your Goals</>
          )}
          { source === 'profile' && (
            <>From Your Linked { type === 'car' ? 'Cars' : 'Homes' }</>
          )}
        </div>
        <RadioButton
          name={ name }
          value={ uid }
          label={ optionName }
        >
          <div className={ styles.content }>
            { !!date && (
              <>
                <div className={ styles.date }>
                  Value on { moment(date).format('MMMM YYYY') }:
                </div>
                &nbsp;
              </>
            )}
            <div className={ styles.amount }>
              { formatUSCurrency(value) }
            </div>
          </div>
        </RadioButton>
      </div>
    ))
  }, [assets, date, name, type])

  return (
    <div className={ styles.assetsList }>
      { childrenChild }
    </div>
  )
}
